<template>
  <div>
    <v-sheet class="sticky">
      <v-toolbar flat color="white">
        <v-text-field
          v-model="search"
          :label="title"
          clearable
          prepend-inner-icon="mdi-magnify"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-card outlined v-if="isAdmin">
          <refresh-assignments-button></refresh-assignments-button>
          <generate-report-assignments-button></generate-report-assignments-button>
          <report-assignment-form></report-assignment-form>
          <more-actions-dropdown></more-actions-dropdown>
        </v-card>
      </v-toolbar>
      <report-assignment-filters v-if="isAdmin"></report-assignment-filters>
    </v-sheet>
    <v-spacer class="py-3"></v-spacer>
    <report-assignments-table
      :reports="filteredReports"
      :search="search_value"
      :isAdmin="isAdmin"
    ></report-assignments-table>
  </div>
</template>

<script>
import GenerateReportAssignmentsButton from "./generate-report-assignments-button.vue";
import RefreshAssignmentsButton from "./refresh-assignments-button.vue";
import ReportAssignmentForm from "./report-assignment-form.vue";
import ReportAssignmentFilters from "./report-assignment-filters.vue";
import ReportAssignmentsTable from "./report-assignments-table.vue";
import MoreActionsDropdown from "./more-actions-dropdown.vue";
export default {
  components: {
    GenerateReportAssignmentsButton,
    RefreshAssignmentsButton,
    ReportAssignmentForm,
    ReportAssignmentFilters,
    ReportAssignmentsTable,
    MoreActionsDropdown,
  },
  data() {
    return {
      search_value: "",
      debounce: "",
    };
  },
  computed: {
    filteredReports() {
      return this.$store.getters["reportsModule/getFilteredReports"];
    },
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    programView() {
      return this.$store.state.reportsModule.programView;
    },
    search: {
      get() {
        return this.search_value;
      },
      set(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(async () => {
          this.search_value = value;
        }, 100);
      },
    },
    title() {
      return this.isAdmin
        ? "Search All Report Assignments"
        : "Search My Report Assignments";
    },
  },
};
</script>
<style scoped>
.sticky {
  background-color: white;
  position: sticky;
  top: 60px;
  z-index: 1;
}
</style>
